import { createContext, useContext, useState, useCallback } from 'react';
import Modal from '../components/Modal';

// แทนที่ window.confirm() แบบ native (เด้งขอบบนจอ ดีไซน์ browser ดีฟอลต์) ด้วย popup
// กลางจอสไตล์เดียวกับที่เหลือในแอป — ใช้ผ่าน useConfirm() แล้ว await ได้เหมือน confirm()
// เดิมทุกที่ ต่างกันแค่เป็น Promise เพราะ modal ต้องรอ user กดปุ่มจริง ๆ
const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null); // { message, options, resolve }

  const confirm = useCallback((message, options = {}) => {
    return new Promise((resolve) => {
      setState({ message, options, resolve });
    });
  }, []);

  const handleChoice = (result) => {
    state?.resolve?.(result);
    setState(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <Modal open={!!state} onClose={() => handleChoice(false)} closeOnBackdrop={false} maxWidth="380px">
        {state && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>
              {state.options.icon || (state.options.danger ? '⚠️' : '❓')}
            </div>
            {state.options.title && (
              <h3 style={{ margin: '0 0 8px', fontSize: '1.1rem', color: '#fff', fontWeight: '700' }}>
                {state.options.title}
              </h3>
            )}
            <p style={{ margin: '0 0 24px', fontSize: '0.9rem', color: '#a0a0b0', lineHeight: 1.6, whiteSpace: 'pre-line' }}>
              {state.message}
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <button
                type="button"
                onClick={() => handleChoice(true)}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: state.options.danger
                    ? 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)'
                    : 'linear-gradient(135deg, #22c55e 0%, #15803d 100%)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '0.95rem',
                  fontWeight: '700',
                  cursor: 'pointer'
                }}
              >
                {state.options.confirmText || 'ยืนยัน'}
              </button>
              <button
                type="button"
                onClick={() => handleChoice(false)}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: '#3d3d5c',
                  color: '#a0a0b0',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                {state.options.cancelText || 'ยกเลิก'}
              </button>
            </div>
          </div>
        )}
      </Modal>
    </ConfirmContext.Provider>
  );
}

// คืนฟังก์ชัน confirm(message, options?) => Promise<boolean> ใช้แทน window.confirm() เดิม
// options: { title, confirmText, cancelText, icon, danger }
export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('useConfirm ต้องถูกเรียกภายใน <ConfirmProvider>');
  return ctx;
}
